
import { SaleLayoutDetailImage } from "@/utils/sale-layouts/detail-image";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppImageStyleEditor from "@/components/layout-editor/ImageStyleEditor.vue";

export default Vue.extend({
	data(){
		return {
			editStyle: false
		};
	},
	props: {
		settings: {
			type: Object as ()=>SaleLayoutDetailImage,
			required: true
		},
		title: {
			type: [Object as ()=>TranslateResult, String],
			required: true
		}
	},
	computed: {
		checkboxValue():boolean {
			if (this.settings.Prop == "CoverImage") {
				return true;
			}
			return false;
		}
	},
	methods: {
		setCheckboxValue(val:boolean){
			if (val) {
				this.settings.Prop = "CoverImage";
			}else{
				this.settings.Prop = "";
			}
		}
	},
	components: {
		AppImageStyleEditor
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
